import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M962,0 C1492.19336,0 1922,429.80664 1922,960 C1922,1490.19336 1492.19336,1920 962,1920 C431.80664,1920 2,1490.19336 2,960 C2,429.80664 431.80664,0 962,0 Z M962,106.666667 C508.630838,106.666667 137.83964,460.224958 110.306565,906.661382 L1813.69343,906.661382 C1786.16036,460.224958 1415.36916,106.666667 962,106.666667 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconOvalHalfLine = /*#__PURE__*/function (_Component) {
  _inherits(IconOvalHalfLine, _Component);

  var _super = _createSuper(IconOvalHalfLine);

  function IconOvalHalfLine() {
    _classCallCheck(this, IconOvalHalfLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconOvalHalfLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconOvalHalf",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconOvalHalfLine.displayName = "IconOvalHalfLine";
  return IconOvalHalfLine;
}(Component);

IconOvalHalfLine.glyphName = 'oval-half';
IconOvalHalfLine.variant = 'Line';
IconOvalHalfLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconOvalHalfLine;
export { IconOvalHalfLine };